/** One device preference and touch-sized width across mobile surfaces.
 * Єдина назва налаштування й ширина для натискань на мобільних поверхнях. */
export const MOBILE_BOT_RAIL_STORAGE_KEY = "hrokbot.mobileBotRail";
export const MOBILE_BOT_RAIL_WIDTH = 56;
